// Lightweight no-op shim for build environments where full monitoring is disabled
// Provides the minimal API surface used by UploadService

export class StorageMonitoringService {
  static startMonitoring(): void {
    // no-op in production build without monitoring backend
  }

  static recordFileUpload(_userId: string, _size: number, _mimeType: string): void {
    // no-op
  }

  static getCurrentMetrics(): Record<string, unknown> {
    return { enabled: false };
  }

  static getActiveAlerts(): Array<Record<string, unknown>> {
    return [];
  }

  static generateReport(): Record<string, unknown> {
    return { generatedAt: new Date().toISOString(), items: [] };
  }
}


